var Curriculog = Curriculog || {};

Curriculog.KeywordFilter = (function ($, _, Backbone, KeywordFilter) {

	KeywordFilter = Backbone.View.extend({

		el: function () {
			return $('#report-9-keyword');
		},

		events: {
			'keypress': 'execute'
		},

		initialize: function(options) {
			this.params = options.params;
		},

		get: function() {
			this.$el.val(this.params.queryParams.get('name'));
		},

		set: function() {
			this.params.queryParams.set('name', this.$el.val());
		},

		execute: function(event) {
			if (event.which !== 13) {
				return;
			} else {
				// Broadcast keyword event
				Backbone.trigger('keyword:press');
			}
		}

	});

	return KeywordFilter;

})($, _, Backbone, Curriculog.KeywordFilter || {});